import { 
  fetchInstitutions, 
  subscribeInstitution, 
  fetchInstitutionHasOutlineTree,
  fetchInstitutionSubscriptionTree, 
  fetchInstitutionCanUserMenu,
  subInstitutionCancelMenu,
  fetchInstitutionCancelMenu,
  fetchInstitutionHasShowMenu,
  checkInstitutionTree,
  checkUserInstitutionTree
} from '../services';
import { MSG, responseErrorHandle } from 'src/common/constants';
import _ from 'lodash';

/**
 * 全部展开
 * @param {*} data 
 * @returns 
 */
const convertTree = (data) => {
  return (
    Array.isArray(data) &&
    data.reduce((pre, cur) => {
      const { children = [] } = cur;
      return pre.concat([cur], convertTree(children || []));
    }, [])
  );
};

/**
 * 过滤掉全部的子节点
 * @param {*} data 
 * @returns 
 */
const filterChild = (data) => {
  return Array.isArray(data) && data.filter(item => item.leaf);
};

export default {
  namespace: 'institutionTab',

  state: {
    institutions: {
      pageSize: 10,
      pageNo: 1,
    }, // 机构列表
    institutionsActiveIndex: null, // 当前选择的索引
    searchParams: {}, // 搜索参数
    isEditable: false, // 全部菜单是否可编辑
    isEditing: false, // 编辑状态中
    selectedMenuTreeKeys: ['nodata'], // 全部菜单树选中的 keys 初始化时传入nodata自断会不显示内容
    institutionOutlineTrees: [], // 全量的功能树
    institutionHasOutlineTrees: [], // 机构已有功能
    institutionHasMenuTrees: [], // 机构已有功能
    institutionMenuTrees: [], // 机构已有菜单
    submitInstitutionOutline: [], // 机构功能提交数据
    submitInstitutionMenu: [], // 机构菜单提交数据
    institutionOutline: [], // 回填机构功能
    institutionMenu: [], // 回填机构菜单
    cleanCheckedKeys: false, // 清除复选内容
    allInstitutionsChildKey: [], // 全量功能树展开后的数据
  },

  effects: {
    /** 
     * 查询机构列表，带分页
     */
    * queryInstitutions ({ payload = {} }, { call, put }) {
      const res = yield call(fetchInstitutions, payload);
      const { success, result, message } = res || {};
      const { list } = result || {};

      if (!success || !Array.isArray(list)) {
        return responseErrorHandle(message || MSG.DEFAULT);
      }

      yield put({
        type: 'updateState',
        institutions: result,
      });
    },

    /** 
     * 查询机构列表，带分页
     * @return {boolean} 返回值告知用户调用结果
     */
    * toSubscribeInstitution ({ payload = {} }, { call }) {
      const res = yield call(subscribeInstitution, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },

    * toSubInstitutionCancelMenu ({ payload = {} }, { call }) {
      const res = yield call(subInstitutionCancelMenu, payload);
      const { success, message } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return res;
    },

    /** 
     * 查询全量的菜单树
     */
    * queryInstitutionOutlineTrees ({ payload = {} }, { call, put }) {
      const res = yield call(fetchInstitutionSubscriptionTree, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        return responseErrorHandle(message || MSG.DEFAULT);
      }

      yield put({
        type: 'updateState',
        institutionOutlineTrees: result,
        allInstitutionsChildKey: _.flow([convertTree, filterChild])(result),
      });
    },
    * queryInstitutionHasOutlineTrees ({ payload = {} }, { call, put }) {
      const res = yield call(fetchInstitutionHasOutlineTree, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        responseErrorHandle(message || MSG.DEFAULT);
        return [];
      }

      yield put({
        type: 'updateState',
        institutionHasOutlineTrees: result,
      });
      return result || [];
    },

    * queryInstitutionHasShowMenuTrees ({ payload = {} }, { call, put }) {
      const res = yield call(fetchInstitutionHasShowMenu, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        responseErrorHandle(message || MSG.DEFAULT);
        return [];
      }

      yield put({
        type: 'updateState',
        institutionHasMenuTrees: result,
      });
      return result || [];
    },
    * queryInstitutionHasMenuTrees ({ payload = {} }, { call }) {
      const res = yield call(fetchInstitutionCancelMenu, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        responseErrorHandle(message || MSG.DEFAULT);
        return [];
      }

      return result || [];
    },
    
    * queryInstitutionMenuTrees ({ payload = {} }, { call, put }) {
      const res = yield call(fetchInstitutionCanUserMenu, payload);
      const { success, result, message } = res || {};

      if (!success || !Array.isArray(result)) {
        return responseErrorHandle(message || MSG.DEFAULT);
      }

      yield put({
        type: 'updateState',
        institutionMenuTrees: result,
      });
    },
    * checkInstitutionTree ({ payload = {} }, { call }) {
      const res = yield call(checkInstitutionTree, payload);
      const { success, message, result } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return result;
    },

    * checkUserInstitutionTree ({ payload = {} }, { call }) {
      const res = yield call(checkUserInstitutionTree, payload);
      const { success, message, result } = res || {};

      if (!success) {
        responseErrorHandle(message || MSG.DEFAULT);

        return false;
      }

      return result;
    },
  },

  reducers: {
    /** 
     * 通用的更新状态的方法
     */
    updateState (state, params) {
      const { ...rest } = params || {};

      return {
        ...state,
        ...rest,
      };
    },
  },
};

